"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRenderData_vue_1 = require("@/client/components/card/CardRenderData.vue");
const CardParty_vue_1 = require("@/client/components/card/CardParty.vue");
const ClientGlobalEventManifest_1 = require("@/client/turmoil/ClientGlobalEventManifest");
const CardDescription_vue_1 = require("@/client/components/card/CardDescription.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'global-event',
    components: {
        CardRenderData: CardRenderData_vue_1.default,
        CardParty: CardParty_vue_1.default,
        CardDescription: CardDescription_vue_1.default,
    },
    props: {
        globalEventName: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        showDistance: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const globalEvent = (0, ClientGlobalEventManifest_1.getGlobalEvent)(this.globalEventName);
        if (globalEvent === undefined) {
            throw new Error(`Can't find card ${this.globalEventName}`);
        }
        return {
            renderData: globalEvent.renderData,
            revealed: globalEvent.revealedDelegate,
            current: globalEvent.currentDelegate,
            description: globalEvent.description,
        };
    },
    computed: {
        klass() {
            const common = 'global-event global-event--' + this.type;
            if (this.showDistance) {
                return common + ' global-event--show-distance';
            }
            return common;
        },
    },
});
